module.exports = __webpack_public_path__ + "static/img/n2.5c68ac0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/n2.png
// module id = 8JjG
// module chunks = 1